import { requestApiClient, requestApiUser } from "../functions";

export default {
    getClient: async () => {
        const res = await requestApiClient('/clients/get-client', 'GET');
        return res;
    },

    login: async (data) => {
        const res = await requestApiClient('/clients/login', 'POST', data);
        return res;
    },

    register: async (data) => {
        const res = await requestApiClient('/clients/register', 'POST', data);
        return res;
    },

    isAuthenticated: async () => {
        try {
            const res = await requestApiClient('/clients/is-authenticated', 'GET', null);
            return res.data;
        } catch (error) {
            console.error('Erreur lors de la vérification de l\'authentification du client:', error);
            return false;
        }
    },

    validateAccessCode: async (code) => {
        try {
            const res = await requestApiClient('/clients/validate-access-code', 'POST', {
                code
            });
            return res;
        } catch (error) {
            return {
                status: 500,
                data: {
                    message: 'Code d\'accès invalide'
                }
            };
        }
    },

    sendPassword: async (clientsIds) => {
        const res = await requestApiUser('/clients/send-password', 'POST', {
            clientsIds
        });
        return res;
    },

    getAll: async () => {
        const res = await requestApiUser('/clients', 'GET');
        return res;
    },

    findById: async (id) => {
        const res = await requestApiUser(`/clients/${id}`, 'GET');
        return res;
    },

    findBySearch: async (search) => {
        const res = await requestApiUser(`/clients/search/${search}`, 'GET');
        return res;
    },

    update: async (data) => {
        const res = await requestApiClient('/clients', 'PUT', data);
        return res;
    },

    resetPassword: async (email) => {
        const res = await requestApiClient('/clients/reset-password', 'POST', { email });
        return res;
    },

    resetPasswordWithToken: async (token, password) => {
        const res = await requestApiClient(`/clients/reset-password/${token}`, 'POST', { password });
        return res;
    },
};